import LocalizedDatePicker from '@/components/inputs/LocalizedDatePicker.vue'

/**
 * Datepickers nativos (`input type="date"`) usan el idioma del sistema.
 * Este plugin registra un selector basado en vue-functional-calendar
 * y el idioma de la app.
 */
export default {
    install(Vue) {
        Vue.component('LocalizedDatePicker', LocalizedDatePicker)
    }
}
